/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {People} from '../../core/_models'
import {IconIsActive} from '../../../../../components/IconIsActive'

type Props = {
  people: People
}

const NameCell: FC<Props> = ({people}) => (
  <div className='d-flex align-items-center'>
    <div className='d-flex flex-column'>
      <span>
        {people?.activeAlert && <IconIsActive text={people?.alertObservation} />}
        {people.name}
      </span>
    </div>
  </div>
)

export {NameCell}
